// extracted by mini-css-extract-plugin
export var dividerLine = "_5e-0";
export var errorBackground = "_5e-1";